import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    first: {
        guid: '',
        x: 0,
        y: 0,
        position: '',
        type: 0,
    },
    second: {
        positionWidth: 0,
    },
    isConnection: false,
};

const connectionSlice = createSlice({
    name: 'connection',
    initialState,
    reducers: {
        setFirst: (state, action) => {
            state.isConnection = true;
            state.first = action.payload;
        },
        setSecond: (state, action) => {
            state.second = action.payload;
        },
        endConnection: (state) => {
            state.isConnection = false;
            state.first = {
                guid: '',
                x: 0,
                y: 0,
                position: '',
                type: 0,
            };
            state.second = {
                positionWidth: 0,
            };
        },
    },
});

export const { actions: connectionActions } = connectionSlice;
export const { reducer: connectionReducer } = connectionSlice;
